export default __webpack_public_path__ + "647e945e69b95ac77f8bc93477879226.svg";